/* global jQuery */

export const initializeAddresses = () => {
  // Set manufacture address onchange
  jQuery("#addresses").on("change", function (ev) {
    const jElement = jQuery(ev.target);
    if (jElement.val() == "") {
      return;
    } // Catch the placeholder text

    var text = jElement.find("option:selected").text();
    if (text) {
      const input = document.querySelector("#recipe_manufactured_at");
      input.value = text;
      input.dispatchEvent(new Event("change")); // Trigger auto_submit
      input.dispatchEvent(new Event("input")); // Trigger 'auto grow'
      jElement.val(""); // Clear selection
    }
  });
};
